var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appointment topic"},[_c('router-view',{attrs:{"appointment":_vm.appointment,"content":_vm.content,"summary":_vm.summary,"selected":_vm.selected,"result":_vm.result}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }